import { PublicOffRounded as PublicOffRoundedIcon, PublicRounded as PublicRoundedIcon } from '@mui/icons-material'
import { Stack, Tooltip } from '@mui/material'
import { t } from 'i18next'

const ActionHeader = ({ isPublic }) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      margin={1}
    >
      {isPublic ? (
        <Tooltip title={t('Public')}>
          <PublicRoundedIcon fontSize="small" />
        </Tooltip>
      ) : (
        <Tooltip title={t('Private')}>
          <PublicOffRoundedIcon fontSize="small" />
        </Tooltip>
      )}
    </Stack>
  )
}

export default ActionHeader
